import { Link } from "@tanstack/react-router"
import type { ProductVisualKind } from "@nova-ai/product-visual-templates/kinds"
import type { ProductVisualStudioCard as StudioCard, StoreCode } from "@nova-ai/shared"

import type { ProductVisualRenderStatus } from "../../hooks/use-product-visual-render"
import type { ProductVisualRenderedPreview } from "../../services/use-product-visual-preview"
import { ProductVisualCellCard } from "./product-visual-cell-card"
import type { EnlargedProductVisual } from "./product-visual-lightbox"

export function ProductVisualStudioCard({
  item,
  store,
  visualKind,
  preview,
  renderStatus = "idle",
  renderError = null,
  onRender,
  regenerationStatus = "idle",
  regenerationError = null,
  onRegenerate,
  onReview,
}: {
  item: StudioCard
  store: StoreCode
  visualKind: ProductVisualKind
  preview?: ProductVisualRenderedPreview
  renderStatus?: ProductVisualRenderStatus
  renderError?: string | null
  onRender?: () => void
  regenerationStatus?: "idle" | "pending"
  regenerationError?: string | null
  onRegenerate?: () => void
  onReview: (item: StudioCard, image: EnlargedProductVisual) => void
}) {
  return (
    <div className="space-y-2">
      <div className="min-w-0 px-1">
        <Link
          to="/products/$sku"
          params={{ sku: item.configSku }}
          search={{ view: "visuals", store, kind: visualKind }}
          className="block truncate text-sm font-semibold text-foreground outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring"
        >
          {item.productTitle}
        </Link>

        <div className="mt-1 truncate font-mono text-xs text-muted-foreground">
          {item.simpleSku}
        </div>
      </div>

      <ProductVisualCellCard
        simpleSku={item.simpleSku}
        visualKind={visualKind}
        cell={item.cell}
        preview={preview}
        renderStatus={renderStatus}
        renderError={renderError}
        regenerationStatus={regenerationStatus}
        regenerationError={regenerationError}
        onEnlarge={(image) => onReview(item, image)}
        {...(onRender ? { onRender } : {})}
        {...(onRegenerate ? { onRegenerate } : {})}
      />
    </div>
  )
}
